import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DataProvider, useData, useTexts } from './data';
import { Content } from './Content';
import NotFound from './NotFound';
import CountdownScreen from './CountdownScreen';
import FunctionCompletedScreen from './FunctionCompletedScreen';
import { ChangeRequest } from './ChangeRequest';
import { AuthProvider } from './operator/AuthContext';
import ProtectedRoute from './operator/ProtectedRoute';
import Login from './operator/Login';
import Dashboard from './operator/Dashboard';
import './styles/bootstrap.scss';
import './styles/app.scss';

function AppRoutes() {
  const TEXTS = useTexts();
  const data = useData();

  const [appState] = useState(() => {
    // Operator routes always accessible
    if (window.location.pathname.includes('/operator')) return 'active';

    // Already determined as completed by DataProvider
    if (data._appState === 'completed') return 'completed';

    const bypassCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('bypass='))
      ?.split('=')[1];
    if (bypassCookie === 'true') return 'active';

    const params = new URLSearchParams(window.location.search);
    if (params.get('bypass') === 'true') return 'active';

    // Check if before launch
    const launchDate = new Date(TEXTS.LAUNCH_DATE).getTime();
    if (new Date().getTime() < launchDate) return 'countdown';

    return 'active';
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('bypass') === 'true') {
      const expires = new Date();
      expires.setDate(expires.getDate() + 30);
      document.cookie = `bypass=true; expires=${expires.toUTCString()}; path=/`;
    }
  }, []);

  if (appState === 'countdown') {
    return <CountdownScreen />;
  }

  if (appState === 'completed') {
    return <FunctionCompletedScreen />;
  }

  return (
    <AuthProvider>
      <Router basename={`/${process.env.PUBLIC_URL}`}>
        <div className="app-container">
          <Routes>
            <Route path="/" element={<Content />} />
            <Route path="/d/:id" element={<Content />} />
            <Route path="/cr/:donorId" element={<ChangeRequest />} />
            <Route path="/operator/login" element={<Login />} />
            <Route
              path="/operator"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

function App() {
  return (
    <DataProvider>
      <AppRoutes />
    </DataProvider>
  );
}

export default App;
